// extracted by mini-css-extract-plugin
export default {"tooltip":"jV-z","arrow":"kV-z"};